import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAS5ZEZXKaafJCvk29WDXFFT6GYlmQueXw",
  authDomain: "marketmind4u-e1868.firebaseapp.com",
  projectId: "marketmind4u-e1868",
  storageBucket: "marketmind4u-e1868.firebasestorage.app",
  messagingSenderId: "595630623037",
  appId: "1:595630623037:web:08416d3b283522e6151d54",
  measurementId: "G-BE841DS2JC"
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
